import { MsalResult, AccessTokenStatus } from '../enums';
import { Consts } from '@/consts';
import { AuthResponse } from 'msal';
import { AccessTokenInfo } from './accessTokenInfo';

export class AuthResult {
	public result: MsalResult;
	private _authResponse: AuthResponse | null;
	private _accessTokenInfo: AccessTokenInfo | null;

	public get authResponse(): AuthResponse | null {
		return this._authResponse;
	}
	public set authResponse(authResponse: AuthResponse | null) {
		if ((authResponse === null) || (authResponse.accessToken === null)
			|| (authResponse.accessToken === Consts.EMPTY_STRING)) {
			this._authResponse = null;
			this._accessTokenInfo = null;
			return;
		}
		this._authResponse = authResponse;
		this._accessTokenInfo = new AccessTokenInfo(
			authResponse.accessToken, AccessTokenStatus.Valid, authResponse.expiresOn);
	}
	public get accessTokenInfo(): AccessTokenInfo {
		if (this._accessTokenInfo === null) {
			return new AccessTokenInfo();
		}
		return this._accessTokenInfo;
	}

	constructor() {
		this.result = MsalResult.UnknownError;
		this._authResponse = null;
		this._accessTokenInfo = null;
	}
}
